/* DiscountCode Vuex State Management
import { stateDiscountCode, gettersDiscountCode, mutationsDiscountCode, actionsDiscountCode} from './discountcode'
*/
import axios from '@axios';

const stateDiscountCode = {
  DiscountCodes: [],
  DiscountCodesTotal: 0,
  DiscountCode: {}
}

const gettersDiscountCode = {
};

const mutationsDiscountCode = {
  DISCOUNTCODE_LIST_SET(state, value) {
    state.DiscountCodes = value.items;
    state.DiscountCodesTotal = value.total;
  },
  DISCOUNTCODE_ITEM_SET(state, value) {
    state.DiscountCode = value;
  }
};

const actionsDiscountCode = {
    fetchDiscountCodes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${ctx.rootState.apiUrl}/api/discountcodes`, queryParams)
          .then(response => {
            const { items, total } = response.data;
            ctx.commit('DISCOUNTCODE_LIST_SET', {
              items: items,
              total: total
            });
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchDiscountCode(ctx, { id }) {
        return new Promise((resolve, reject) => {
            axios
            .get(`${ctx.rootState.apiUrl}/api/discountcodes/${id}`)
            .then(response => {
              ctx.commit('DISCOUNTCODE_ITEM_SET', response.data);
              resolve(response)
            })
            .catch(error => reject(error))
        })
    },
    updateDiscountCode(ctx, { id, entity }) {

      ctx.commit('DISCOUNTCODE_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .put(`${ctx.rootState.apiUrl}/api/discountcodes/${id}`, entity)
        .then(response => {
          ctx.commit('DISCOUNTCODE_ITEM_SET', response.data); // allow for server-side data
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: " Saved." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    createDiscountCode(ctx, { entity }) {

      ctx.commit('DISCOUNTCODE_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .post(`${ctx.rootState.apiUrl}/api/discountcodes/create`, entity)
        .then(response => {
          ctx.commit('DISCOUNTCODE_ITEM_SET', response.data); // allow for server-side data
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    fetchDiscountCodesLookup(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        if (queryParams.id) {
          axios
            .get(`${ctx.rootState.apiUrl}/api/discountcodes/${queryParams.id}`)
            .then(response => {
              resolve(response.data)
            })
            .catch(error => reject(error));
        } else {
          axios
            .post(`${ctx.rootState.apiUrl}/api/discountcodes`, queryParams)
            .then(response => {
              resolve(response.data.items);
            })
            .catch(error => reject(error));
        }
      });
    },
}

export {
  stateDiscountCode,
  gettersDiscountCode,
  mutationsDiscountCode,
  actionsDiscountCode
}